var _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBtnSocialFacebook = function SvgBtnSocialFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "btn-social-facebook_svg__a",
    d: "M0 0h50v50H0z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "btn-social-facebook_svg__b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#btn-social-facebook_svg__a",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#btn-social-facebook_svg__b)",
      fill: "currentColor"
    },
    d: "M25 0C11.193 0 0 11.193 0 25s11.193 25 25 25 25-11.193 25-25S38.807 0 25 0zm9 13.662h-3.494A2.503 2.503 0 0 0 28 16.16V18h6v6.105h-6V42h-8V24.105h-4V18h4v-3.328C20 10.988 22.996 8 26.689 8H34v5.662z"
  }));
};
export default SvgBtnSocialFacebook;